import { Edit2, Eye } from 'iconsax-react';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';
import { CreateOrEditReminderTemplate } from '@src/shared/features/reminders/dialogs/create-or-edit-reminder-template';
import { ViewReminderTemplateDetails } from '@src/shared/features/reminders/dialogs/view-reminder-template-details';
import { REMINDER_CHANNELS } from '@src/shared/types/reminder';
import type { TReminderTemplate } from '@src/shared/types/reminder-template';
import { SyncReminderTemplateButton } from './sync-reminder-template-button';
import { Button } from '@src/design-system/button';
import { entities } from '@src/shared/constants/entities';
import { HasPermission } from '@src/features/roles/guards/has-permission';
import { SingleDeleteAction } from '@src/design-system/molecules/ticlick-table/actions/single-delete-action';
import reminderTemplateApi from '../services/reminder-template-api';

export const ReminderTemplateTableRowActions = ({
  reminderTemplate,
}: {
  reminderTemplate: TReminderTemplate;
}) => {
  const { id, channel, status } = reminderTemplate;
  const isEmailTemplate = channel === REMINDER_CHANNELS.email;
  const { mutate: deleteReminderTemplate, isPending } =
    reminderTemplateApi.useDelete();

  return (
    <div
      className='flex items-center justify-end gap-1'
      onClick={(e) => e.stopPropagation()}
    >
      <Dialog>
        <DialogTrigger asChild>
          <Button
            variant='ghost'
            size={'iconSm'}
          >
            <Eye
              size='20'
              cursor='pointer'
              variant='TwoTone'
              color='var(--color-gray-800)'
            />
          </Button>
        </DialogTrigger>
        <DialogContent className='flex w-full max-w-[78%] flex-col overflow-hidden'>
          <ViewReminderTemplateDetails reminderTemplate={reminderTemplate} />
        </DialogContent>
      </Dialog>

      {isEmailTemplate ? (
        <Dialog>
          <DialogTrigger asChild>
            <Button
              variant='ghost'
              size={'iconSm'}
            >
              <Edit2
                size='14'
                className='text-gray-800'
                variant='TwoTone'
              />
            </Button>
          </DialogTrigger>
          <DialogContent
            onOpenAutoFocus={(e) => e.preventDefault()}
            className='flex w-full max-w-[78%] flex-col overflow-hidden'
          >
            <CreateOrEditReminderTemplate reminderTemplate={reminderTemplate} />
          </DialogContent>
        </Dialog>
      ) : null}

      <HasPermission
        entity={entities.reminderTemplate}
        action='delete'
      >
        <SingleDeleteAction
          id={id}
          label='template'
          isLoading={isPending}
          onConfirm={(closeModal) =>
            deleteReminderTemplate({ id }, { onSuccess: closeModal })
          }
        />
      </HasPermission>

      <SyncReminderTemplateButton
        id={id}
        channel={channel}
        status={status}
      />
    </div>
  );
};
